import Api from '../utils/api'

export const logInService = async (user) => {
    try {
        const response = await Api.post(`auth/logIn`, user)
        if (response.data?.token) {
            localStorage.setItem('token', `Token ${response.data.token}`)
        }
        return response
    } catch (error) {
        return error.response
    }
}

export const signOutService = async () => {
    try {
        if (localStorage.getItem('token')) {
            localStorage.removeItem('token')
            return true
        } else {
            return false
        }
    } catch (error) {
        return false
    }
}

export const verifyTokenService = async () => {
    try {
        const token = localStorage.getItem('token')
        if (token) {
            const response = await Api.get(
                `auth/me`,
                {},
                {
                    authorization: token,
                },
            )
            return response.data
        }
        return false
    } catch (error) {
        return false
    }
}
